const locale: Locale = {
  ko: {
    answered: '답변완료',
    rejected: '청원반려',
    expired: '청원기간만료',
    waiting: '답변대기중',
    progress: '청원진행중',
    prior: '사전동의진행중',

    total: '총 ',
    signed: ' 명이 동의했습니다.',

    description: '청원내용',
    answer: '답변',
    rejection: '반려 사유',

    copyBtn: '복사',
    copied: 'URL이 복사되었습니다.',
    share: '공유하기',

    agree: '청원동의 ',
    people: ' 명',
  },
  en: {
    answered: 'Responded',
    rejected: 'Rejected',
    expired: 'Expired',
    waiting: 'Waiting for Answer',
    progress: 'In Progress',
    prior: 'Prior Consent',

    total: 'Total ',
    signed: ' people have agreed.',

    description: 'Description',
    answer: 'Answer',
    rejection: 'Reason for Rejection',

    copyBtn: 'Copy',
    copied: 'URL Copied.',
    share: 'Share',

    agree: '',
    people: ' people agreed to this',
  },
}

export default locale
